import React, { useEffect, useState } from "react"
import axios from "axios"

const API = process.env.REACT_APP_API_URL || "http://localhost:3001/api"

const fmtMoeda = (v:any) => v ? `R$ ${parseFloat(v).toLocaleString("pt-BR",{minimumFractionDigits:2})}` : "—"
const fmtData  = (d:any) => d ? new Date(d).toLocaleDateString("pt-BR") : "—"

const PLANOS_PADRAO = [
  {ativos:300,  valor:250,  nome:"Starter"},
  {ativos:600,  valor:450,  nome:"Pro"},
  {ativos:800,  valor:560,  nome:"Business"},
  {ativos:9999, valor:0,    nome:"Enterprise"},
]

export default function Licencas() {
  const [licencas, setLicencas]   = useState<any[]>([])
  const [planos, setPlanos]       = useState<any[]>([])
  const [clientes, setClientes]   = useState<any[]>([])
  const [modal, setModal]         = useState(false)
  const [modalPlanos, setModalPlanos] = useState(false)
  const [editando, setEditando]   = useState<any>(null)
  const [form, setForm]           = useState<any>({
    cliente_id:"", plano_licenca_id:"", valor_negociado:"",
    white_label:false, nome_marca:"", data_inicio:new Date().toISOString().split("T")[0],
    data_vencimento:"", obs:""
  })
  const [formPlano, setFormPlano] = useState<any>({nome:"",limite_ativos:"",valor_mensal:"",descricao:""})
  const [loading, setLoading]     = useState(true)

  const carregar = async () => {
    try {
      const [l, p, c] = await Promise.all([
        axios.get(`${API}/licencas`),
        axios.get(`${API}/planos-licenca`),
        axios.get(`${API}/clientes`)
      ])
      setLicencas(l.data)
      setPlanos(p.data)
      setClientes(c.data.filter((c:any)=>c.tipo_conta==="empresa_rastreamento"||!c.tipo_conta))
    } catch {} finally { setLoading(false) }
  }

  useEffect(()=>{ carregar() },[])

  const salvar = async () => {
    if (!form.cliente_id) return alert("Selecione a empresa")
    if (!form.plano_licenca_id) return alert("Selecione o plano")
    try {
      if (editando) await axios.put(`${API}/licencas/${editando.id}`, form)
      else await axios.post(`${API}/licencas`, form)
      setModal(false); carregar()
    } catch(e:any) { alert(e.response?.data?.erro||"Erro ao salvar") }
  }

  const salvarPlano = async () => {
    if (!formPlano.nome||!formPlano.limite_ativos||!formPlano.valor_mensal) return alert("Preencha todos os campos")
    try {
      await axios.post(`${API}/planos-licenca`, formPlano)
      setModalPlanos(false)
      setFormPlano({nome:"",limite_ativos:"",valor_mensal:"",descricao:""})
      carregar()
    } catch(e:any) { alert(e.response?.data?.erro||"Erro ao salvar") }
  }

  const encerrar = async (id:string) => {
    if (!window.confirm("Encerrar licença?")) return
    try { await axios.put(`${API}/licencas/${id}`,{status:"encerrada"}); carregar() } catch {}
  }

  const planoSel = planos.find((p:any)=>p.id===form.plano_licenca_id)
  const valorFinal = form.valor_negociado ? parseFloat(form.valor_negociado) : planoSel ? parseFloat(planoSel.valor_mensal) : 0

  const totalMensal = licencas.filter(l=>l.status==="ativa").reduce((s:number,l:any)=>s+parseFloat(l.valor_negociado||l.valor_mensal||0),0)
  const totalAtivos = licencas.filter(l=>l.status==="ativa").reduce((s:number,l:any)=>s+parseInt(l.limite_ativos||0),0)

  return (
    <div style={{padding:24,height:"100%",overflowY:"auto"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
        <div>
          <h2 style={{fontSize:20,fontWeight:700}}>🔑 Licenças da Plataforma</h2>
          <p style={{fontSize:13,color:"#64748b"}}>Gerencie as empresas que utilizam o MoobiFleet</p>
        </div>
        <div style={{display:"flex",gap:8}}>
          <button className="btn btn-ghost" onClick={()=>setModalPlanos(true)}>📋 Planos</button>
          <button className="btn btn-primary" onClick={()=>{setEditando(null);setModal(true)}}>+ Nova licença</button>
        </div>
      </div>

      {/* Cards resumo */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:16,marginBottom:24}}>
        {[
          {label:"Licenças ativas", valor:licencas.filter(l=>l.status==="ativa").length, cor:"#22c55e", icone:"✅"},
          {label:"Receita mensal", valor:fmtMoeda(totalMensal), cor:"#0ea5e9", icone:"💰"},
          {label:"Ativos licenciados", valor:totalAtivos.toLocaleString("pt-BR"), cor:"#f59e0b", icone:"🚗"},
          {label:"White Label", valor:licencas.filter(l=>l.white_label&&l.status==="ativa").length, cor:"#8b5cf6", icone:"🏷️"},
        ].map((s,i)=>(
          <div key={i} className="card" style={{padding:"14px 16px"}}>
            <div style={{fontSize:22,marginBottom:6}}>{s.icone}</div>
            <div style={{fontSize:18,fontWeight:700,color:s.cor}}>{s.valor}</div>
            <div style={{fontSize:11,color:"#64748b"}}>{s.label}</div>
          </div>
        ))}
      </div>

      {/* Planos disponíveis */}
      <div style={{marginBottom:24}}>
        <div style={{fontSize:13,fontWeight:700,color:"#94a3b8",marginBottom:12}}>📋 Planos disponíveis</div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))",gap:12}}>
          {planos.map((p:any)=>(
            <div key={p.id} className="card" style={{padding:"12px 16px",border:"1px solid #2d4166"}}>
              <div style={{fontWeight:700,fontSize:14,color:"#f1f5f9",marginBottom:4}}>{p.nome}</div>
              <div style={{fontSize:22,fontWeight:700,color:"#22c55e",marginBottom:4}}>
                {p.valor_mensal>0 ? fmtMoeda(p.valor_mensal) : "Sob consulta"}
              </div>
              <div style={{fontSize:11,color:"#64748b"}}>
                {p.limite_ativos>=9999 ? "Ilimitado" : `Até ${p.limite_ativos} ativos`}
              </div>
              {p.descricao && <div style={{fontSize:10,color:"#475569",marginTop:4}}>{p.descricao}</div>}
            </div>
          ))}
        </div>
      </div>

      {/* Tabela licenças */}
      <div className="card" style={{padding:0,overflow:"hidden"}}>
        <table style={{width:"100%",borderCollapse:"collapse"}}>
          <thead>
            <tr style={{background:"#0d1b2e"}}>
              {["Empresa","Plano","Limite","Valor mensal","White Label","Início","Vencimento","Status","Ações"].map(h=>(
                <th key={h} style={{padding:"10px 14px",textAlign:"left",fontSize:11,
                  color:"#64748b",fontWeight:600,textTransform:"uppercase"}}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={9} style={{padding:24,textAlign:"center",color:"#64748b"}}>Carregando...</td></tr>
            ) : licencas.length===0 ? (
              <tr><td colSpan={9} style={{padding:24,textAlign:"center",color:"#64748b"}}>Nenhuma licença cadastrada</td></tr>
            ) : licencas.map((l:any)=>(
              <tr key={l.id} style={{borderBottom:"1px solid rgba(45,65,102,0.4)"}}>
                <td style={{padding:"10px 14px"}}>
                  <div style={{fontWeight:600,fontSize:13}}>{l.cliente_nome}</div>
                  {l.white_label && l.nome_marca && <div style={{fontSize:10,color:"#8b5cf6"}}>🏷️ {l.nome_marca}</div>}
                </td>
                <td style={{padding:"10px 14px",fontSize:12}}>{l.plano_nome}</td>
                <td style={{padding:"10px 14px",fontSize:12,color:"#0ea5e9"}}>
                  {l.limite_ativos>=9999?"Ilimitado":`${l.limite_ativos} ativos`}
                </td>
                <td style={{padding:"10px 14px"}}>
                  <div style={{fontSize:13,fontWeight:600,color:"#22c55e"}}>{fmtMoeda(l.valor_negociado||l.valor_mensal)}</div>
                  {l.valor_negociado && parseFloat(l.valor_negociado)!==parseFloat(l.valor_mensal) && (
                    <div style={{fontSize:10,color:"#f59e0b"}}>⚡ Negociado</div>
                  )}
                </td>
                <td style={{padding:"10px 14px"}}>
                  {l.white_label
                    ? <span style={{fontSize:10,background:"#3b0764",color:"#c4b5fd",padding:"2px 8px",borderRadius:10}}>✅ White Label</span>
                    : <span style={{fontSize:10,color:"#475569"}}>MoobiFleet</span>}
                </td>
                <td style={{padding:"10px 14px",fontSize:12}}>{fmtData(l.data_inicio)}</td>
                <td style={{padding:"10px 14px",fontSize:12,
                  color:l.data_vencimento&&new Date(l.data_vencimento)<new Date()?"#f87171":"#94a3b8"}}>
                  {fmtData(l.data_vencimento)||"Em aberto"}
                </td>
                <td style={{padding:"10px 14px"}}>
                  <span style={{fontSize:10,padding:"2px 8px",borderRadius:10,
                    background:l.status==="ativa"?"#14532d":"#1e293b",
                    color:l.status==="ativa"?"#4ade80":"#64748b"}}>
                    {l.status}
                  </span>
                </td>
                <td style={{padding:"10px 14px"}}>
                  <div style={{display:"flex",gap:4}}>
                    <button className="btn btn-ghost" style={{padding:"4px 8px",fontSize:11}}
                      onClick={()=>{setEditando(l);setForm({...l,plano_licenca_id:l.plano_licenca_id,data_inicio:l.data_inicio?.split("T")[0],data_vencimento:l.data_vencimento?.split("T")[0]||""});setModal(true)}}>✏️</button>
                    {l.status==="ativa" && (
                      <button className="btn btn-ghost" style={{padding:"4px 8px",fontSize:11,color:"#f87171"}}
                        onClick={()=>encerrar(l.id)}>🔒</button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal Licença */}
      {modal && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:1000,
          display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
          <div className="card" style={{width:"100%",maxWidth:540,maxHeight:"90vh",overflowY:"auto"}}>
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:20}}>
              <h3>{editando?"✏️ Editar licença":"🔑 Nova licença"}</h3>
              <button className="btn btn-ghost" style={{padding:"4px 8px"}} onClick={()=>setModal(false)}>✕</button>
            </div>
            <div className="form-grid">
              <div className="form-group full">
                <label>Empresa *</label>
                <select value={form.cliente_id} onChange={e=>setForm({...form,cliente_id:e.target.value})}>
                  <option value="">— Selecione —</option>
                  {clientes.map((c:any)=><option key={c.id} value={c.id}>{c.razao_social}</option>)}
                </select>
              </div>
              <div className="form-group full">
                <label>Plano *</label>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                  {planos.map((p:any)=>(
                    <div key={p.id} onClick={()=>setForm({...form,plano_licenca_id:p.id,valor_negociado:""})}
                      style={{padding:"10px 14px",borderRadius:8,cursor:"pointer",
                        border:`2px solid ${form.plano_licenca_id===p.id?"#22c55e":"#2d4166"}`,
                        background:form.plano_licenca_id===p.id?"#0d2e1a":"transparent"}}>
                      <div style={{fontWeight:600,fontSize:12,color:form.plano_licenca_id===p.id?"#22c55e":"#f1f5f9"}}>{p.nome}</div>
                      <div style={{fontSize:13,fontWeight:700,color:"#22c55e"}}>{p.valor_mensal>0?fmtMoeda(p.valor_mensal):"Personalizado"}</div>
                      <div style={{fontSize:10,color:"#64748b"}}>{p.limite_ativos>=9999?"Ilimitado":`${p.limite_ativos} ativos`}</div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="form-group">
                <label>💰 Valor negociado (opcional)</label>
                <div style={{position:"relative"}}>
                  <span style={{position:"absolute",left:10,top:"50%",transform:"translateY(-50%)",color:"#64748b",fontSize:13}}>R$</span>
                  <input type="number" value={form.valor_negociado} step="0.01" min="0"
                    onChange={e=>setForm({...form,valor_negociado:e.target.value})}
                    placeholder={planoSel?.valor_mensal||"0,00"} style={{paddingLeft:32}} />
                </div>
                {planoSel && <div style={{fontSize:10,color:"#475569",marginTop:3}}>Padrão: {fmtMoeda(planoSel.valor_mensal)}</div>}
              </div>
              <div className="form-group">
                <label>📅 Data início</label>
                <input type="date" value={form.data_inicio} onChange={e=>setForm({...form,data_inicio:e.target.value})} />
              </div>
              <div className="form-group">
                <label>📅 Data vencimento</label>
                <input type="date" value={form.data_vencimento} onChange={e=>setForm({...form,data_vencimento:e.target.value})} />
              </div>
              <div className="form-group">
                <label>🏷️ White Label</label>
                <div style={{display:"flex",gap:8,marginTop:4}}>
                  {[{v:false,l:"MoobiFleet (padrão)"},{v:true,l:"White Label (+custo)"}].map(op=>(
                    <div key={String(op.v)} onClick={()=>setForm({...form,white_label:op.v})}
                      style={{flex:1,padding:"8px 12px",borderRadius:8,cursor:"pointer",textAlign:"center",
                        border:`2px solid ${form.white_label===op.v?"#8b5cf6":"#2d4166"}`,
                        background:form.white_label===op.v?"#2e1065":"transparent",
                        fontSize:11,color:form.white_label===op.v?"#c4b5fd":"#94a3b8"}}>
                      {op.l}
                    </div>
                  ))}
                </div>
              </div>
              {form.white_label && (
                <div className="form-group full">
                  <label>Nome da marca</label>
                  <input value={form.nome_marca} onChange={e=>setForm({...form,nome_marca:e.target.value})}
                    placeholder="Nome da empresa/marca" />
                </div>
              )}
              {valorFinal > 0 && (
                <div className="form-group full">
                  <div style={{background:"#0c2a4a",border:"1px solid #0ea5e9",borderRadius:8,padding:12}}>
                    <div style={{fontSize:11,color:"#38bdf8",marginBottom:6,fontWeight:600}}>📊 Resumo</div>
                    <div style={{display:"flex",justifyContent:"space-between"}}>
                      <span style={{fontSize:12,color:"#94a3b8"}}>Valor mensal</span>
                      <span style={{fontSize:14,fontWeight:700,color:"#22c55e"}}>{fmtMoeda(valorFinal)}</span>
                    </div>
                    <div style={{display:"flex",justifyContent:"space-between",marginTop:4}}>
                      <span style={{fontSize:11,color:"#64748b"}}>Limite de ativos</span>
                      <span style={{fontSize:11,color:"#0ea5e9"}}>{planoSel?.limite_ativos>=9999?"Ilimitado":`${planoSel?.limite_ativos} ativos`}</span>
                    </div>
                    {form.white_label && <div style={{fontSize:10,color:"#8b5cf6",marginTop:4}}>🏷️ White Label incluído</div>}
                  </div>
                </div>
              )}
              <div className="form-group full">
                <label>Observações</label>
                <input value={form.obs} onChange={e=>setForm({...form,obs:e.target.value})}
                  placeholder="Condições especiais, notas..." />
              </div>
            </div>
            <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:20}}>
              <button className="btn btn-ghost" onClick={()=>setModal(false)}>Cancelar</button>
              <button className="btn btn-primary" onClick={salvar}>💾 {editando?"Salvar":"Criar licença"}</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Planos */}
      {modalPlanos && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:1000,
          display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
          <div className="card" style={{width:"100%",maxWidth:480}}>
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:16}}>
              <h3>📋 Novo plano de licença</h3>
              <button className="btn btn-ghost" style={{padding:"4px 8px"}} onClick={()=>setModalPlanos(false)}>✕</button>
            </div>
            <div className="form-grid">
              <div className="form-group full">
                <label>Nome do plano *</label>
                <input value={formPlano.nome} onChange={e=>setFormPlano({...formPlano,nome:e.target.value})} placeholder="Ex: Ultra 1000" />
              </div>
              <div className="form-group">
                <label>Limite de ativos *</label>
                <input type="number" value={formPlano.limite_ativos} onChange={e=>setFormPlano({...formPlano,limite_ativos:e.target.value})} placeholder="Ex: 1000" />
              </div>
              <div className="form-group">
                <label>Valor mensal (R$) *</label>
                <input type="number" value={formPlano.valor_mensal} step="0.01" onChange={e=>setFormPlano({...formPlano,valor_mensal:e.target.value})} placeholder="0,00" />
              </div>
              <div className="form-group full">
                <label>Descrição</label>
                <input value={formPlano.descricao} onChange={e=>setFormPlano({...formPlano,descricao:e.target.value})} placeholder="Descrição do plano..." />
              </div>
            </div>
            <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:16}}>
              <button className="btn btn-ghost" onClick={()=>setModalPlanos(false)}>Cancelar</button>
              <button className="btn btn-primary" onClick={salvarPlano}>💾 Criar plano</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
